export default __webpack_public_path__ + "static/media/Scenery07.429bd327.jpg";